import React, { useEffect, useRef, useState } from "react";
import { object } from "prop-types";
import get from "lodash/get";
import trimStart from "lodash/trimStart";

import FourColPortraitStories from "../../../../arrow/components/Rows/FourColPortraitStories";

export const ArrowFourColPortraitStories = ({ collection, pageType }) => {
  const config = {
    buttonText: "Read More",
    showImagePlaceholder: true,
    showSection: false,
    showReadTime: false,
  };

  const isShortVideo = get(collection, ["associated-metadata", "is_short_videos"], false);

  const [items, setItems] = useState(collection.items);

  // 🔑 persistent ref (survives re-renders & back navigation)
  const isAliveRef = useRef(true);

  // Mark component as alive / dead
  useEffect(() => {
    isAliveRef.current = true;
    return () => {
      isAliveRef.current = false;
    };
  }, []);

  // Sync normal collections
  useEffect(() => {
    if (!isShortVideo) {
      setItems(collection.items);
    }
  }, [collection.items, isShortVideo]);

  // Fetch shorts safely
  useEffect(() => {
    if (!isShortVideo) return;

    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/ytshorts-data/shorts.json"
        );

        const data = await res.json();

        // 🛑 HARD STOP if component is gone
        if (!isAliveRef.current) return;

        if (Array.isArray(data)) {
          let filteredData = data;

          // ✅ Apply filter ONLY for collection page
          if (pageType === "collection-page") {
            const budgetRegex = /#(budget2026|unionbudget2026)/i;

            filteredData = data.filter(
              (item) => typeof item?.story?.description === "string" && budgetRegex.test(item.story.description)
            );
          }

          // Normalize slug (your existing logic)
          const normalizedData = filteredData.map((item) =>
            item?.story?.slug
              ? {
                  ...item,
                  story: {
                    ...item.story,
                    slug: trimStart(item.story.slug, "/"),
                  },
                }
              : item
          );

          setItems(normalizedData.slice(0, 4));
        }
      } catch (error) {
        // Ignore silently during navigation
        if (isAliveRef.current) {
          console.log("YT Shorts Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [isShortVideo, pageType]);

  return (
    <FourColPortraitStories
      collection={{ ...collection, items }}
      config={config}
      isLoadMoreVisible
      pageType={pageType}
    />
  );
};

ArrowFourColPortraitStories.propTypes = {
  collection: object,
};

ArrowFourColPortraitStories.storyLimit = 14;
